/**
 * Stat definitions used to build the standings columns of the event table. The `code` matches the
 * participant statistic type coming from the tournament feed (see ParticipantStatisticTypeEnum).
 *
 * @readonly
 * @type {Array<{code: string, fieldKey: string, labelKey: string}>}
 */
export const STAT_DEFINITIONS = [
    { code: 'MP', fieldKey: 'gamesPlayed', labelKey: '$EVENT_TABLE.STATS.MATCHES_PLAYED_SHORT' },
    { code: 'W', fieldKey: 'wins', labelKey: '$EVENT_TABLE.STATS.WINS_SHORT' },
    { code: 'D', fieldKey: 'draws', labelKey: '$EVENT_TABLE.STATS.DRAWS_SHORT' },
    { code: 'L', fieldKey: 'losses', labelKey: '$EVENT_TABLE.STATS.LOSSES_SHORT' },
    { code: 'GF', fieldKey: 'goalsFor', labelKey: '$EVENT_TABLE.STATS.GOALS_FOR_SHORT' },
    { code: 'GA', fieldKey: 'goalsAgainst', labelKey: '$EVENT_TABLE.STATS.GOALS_AGAINST_SHORT' },
    {
        code: 'GD',
        fieldKey: 'goalDifference',
        labelKey: '$EVENT_TABLE.STATS.GOAL_DIFFERENCE_SHORT',
    },
    { code: 'PTS', fieldKey: 'points', labelKey: '$EVENT_TABLE.STATS.POINTS_SHORT' },
];

/**
 * Toggle views shown in the top-right corner of the table page.
 *
 * @readonly
 * @enum {string}
 */
export const VIEW = {
    GROUP: 'group',
    KNOCKOUT: 'knockout',
};
